import { CALENDAR } from "../../routes";
import type { WizardInitialFormData, WizardStepName } from "../notices/wizardSession";

/** What the Add event wizard starts with, beyond the day clicked: the title, who it's for, its time and place, and so on. */
export type AddEventFormData = WizardInitialFormData;

/**
 * A new Event another page asks Calendar to open, filled in for the person to check.
 * `date` is a day picked on the Calendar, which starts at 09:00; a day handed over
 * with its own time goes in `initialFormData`. `startAt` is the step it opens on.
 */
export type AddEventHandover = { date: Date | null; initialFormData: AddEventFormData; startAt?: WizardStepName };

/** What another page hands Calendar in router state: a day to show, or an Event to start. */
export type CalendarHandover = { date?: Date; addEvent?: AddEventHandover };

/** Calendar's router state, read on arrival; anything else is no handover. */
export const readCalendarHandover = (state: unknown): CalendarHandover => {
  const { date, addEvent } = (state ?? {}) as CalendarHandover;
  return {
    ...(date instanceof Date ? { date } : {}),
    ...(addEvent ? { addEvent } : {}),
  };
};

export const toCalendar = (handover: CalendarHandover) => ({ pathname: CALENDAR, state: handover });
